import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-angle-down-icon',
  templateUrl: './navigation-angle-down.component.html'
})
export class NavigationAngleDownComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
